import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { URLS } from 'i2g-ng-utils';
import { ITrackingAction, ITrackingObject } from 'i2g-ng-tracking';
import { IIcon, IconSizesEnum } from '../icon/icon.component';

/**
 * Powered by Invoice2go component
 *
 * NOTE:
 * I didn't include the icon svg here because the icon is also used by other component ie page not found
 * so better to depends on the icon set by the project
 */
@Component({
  selector: 'i2g-powered-by',
  templateUrl: 'powered-by.component.html',
  styleUrls: ['powered-by.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoweredByComponent implements OnInit {
  /**
   * Label to put beside the logo
   */
  @Input() label = 'Powered by';

  /**
   * Tracking object
   */
  @Input() trackingObject: ITrackingObject;

  /**
   * Tracking action the component is clicked/tapped
   */
  @Input() trackingAction: ITrackingAction;

  invoice2goLogoIcon: IIcon;
  invoice2goUrl: string;
  logoTapped: ITrackingAction;

  constructor() {}

  ngOnInit() {
    this.invoice2goLogoIcon = {
      name: 'invoice2go-logo-white',
      size: IconSizesEnum.custom,
    };
    this.invoice2goUrl = URLS.INVOICE2GO_FEATURES;
  }
}
